import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

type Props = {
    login : () => void;
};

const AuthError : React.FC<Props> = ({login} : Props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Card>
                <CardContent>
                    <Typography variant="h2" gutterBottom={true}>Sign In</Typography>
                    <Typography variant="body1">
                        An error occurred during authentication, please try again!
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" color="secondary" onClick={login}>
                        Sign in
                    </Button>
                </CardActions>
            </Card>
        </div>
    );
};

export default AuthError;
